import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/dashboard/index.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   alias: '/main'
    // },
    {
      path: '/',
      component: Dashboard,
      redirect: '/main',
      children: [
        {
          path: 'main',
          component: () => import('@/views/main/index'),
          name: 'Main',
          alias: '/',
        },
        {
          path: 'enterprise',
          component: () => import('@/views/enterprise/index'),
          name: 'Enterprise'
        },
        {
          path: 'product/manshu',
          component: () => import('@/views/product/manshu'),
          name: 'Manshu'
        },
        {
          path: 'product/lixiu',
          component: () => import('@/views/product/lixiu'),
          name: 'Lixiu'
        },
        {
          path: 'product/ainose',
          component: () => import('@/views/product/ainose'),
          name: 'Ainose'
        },
        {
          path: 'product/hetong',
          component: () => import('@/views/product/hetong'),
          name: 'Hetong'
        },
        {
          path: 'product/meiti',
          component: () => import('@/views/product/meiti'),
          name: 'Meiti'
        },
        {
          path: 'honor',
          component: () => import('@/views/honor/index'),
          name: 'Honor'
        },
        {
          path: 'case',
          component: () => import('@/views/case/index'),
          name: 'Case'
        },
        {
          path: 'security/QA',
          component: () => import('@/views/security/QA'),
          name: 'QA'
        },
        {
          path: 'security/authenticity',
          component: () => import('@/views/security/Authenticity'),
          name: 'Authenticity'
        },
        {
          path: 'contact',
          component: () => import('@/views/contact/index'),
          name: 'Contact'
        },
        {
          path: 'information',
          component: () => import('@/views/information/index'),
          name: 'Information',
          children: [
            {
              path: 'list',
              component: () => import('@/views/information/component/list'),
              name: 'informationList'
            },
            {
              path: 'details',
              component: () => import('@/views/information/component/details'),
              name: 'informationDetails'
            }
          ],
        }
      ]
    }
  ]
})
